export const environment = {
  // apiUrl: "https://apple-sundae-26371.herokuapp.com",
  // apiUrl: "http://localhost:3005/api/v1",
  apiUrl: "https://allvirtuous.net/api/v1",
  firebase: {
    apiKey: "AIzaSyAKGbyiuhJ0Q_7u28bvYWw_OY6shl_ed08",
    authDomain: "avscale-dcf07.firebaseapp.com",
    databaseURL: "https://avscale-dcf07.firebaseio.com",
    projectId: "avscale-dcf07",
    storageBucket: "avscale-dcf07.appspot.com",
    messagingSenderId: "741292757865"
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts